window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.casinoMaratonRepo = function () {

    var url = 'api/casinomaraton';

    var get = function (sveRezultate, nadimak) {


        return fetch(url + casino.repos.base.serializeGetParams({
                sveRezultate: sveRezultate,
                nadimak: nadimak || ''
            }), {
                credentials: repos.base.credentials
            })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);

    };

    return {
        get: get
    }

}();